import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import netBeautyBankPointsAvailableSelector from 'selectors/basket/netBeautyBankPointsAvailableSelector';
import availableBiPointsSelector from 'selectors/basket/availableBiPointsSelector';

const { wrapHOC } = FrameworkUtils;

const fields = state => ({
    netBeautyBankPointsAvailable: netBeautyBankPointsAvailableSelector(state),
    availableBiPoints: availableBiPointsSelector(state)
});

const withStickyLoyaltyProfileBannerProps = wrapHOC(connect(fields));

export {
    withStickyLoyaltyProfileBannerProps, fields
};
